<template>
    <div class="pageinfo">
        <a-pagination
            showSizeChanger
            showQuickJumper
            :total="pagination.total"
            :current="pagination.current"
            :pageSize="pagination.pageSize"
            :pageSizeOptions="pageSizeOptions"
            :showTotal="showTotal"
            @change="onChange"
            @showSizeChange="onShowSizeChange"
        />
    </div>
</template>

<script>
export default {
    methods: {
        pagejump(page, pagesize) {
            let query = {
                page,
                pagesize
            };
            query = { ...this.$route.query, ...query };
            this.$router.push({
                query
            });
        },
        onChange(page, pagesize) {
            this.pagejump(page, pagesize);
        },
        onShowSizeChange(current, pagesize) {
            this.$store.commit("save", { pagesize });
            this.pagejump(current, pagesize);
        },
        showTotal(total, range) {
            if (total == "0") {
                return `共 0 条 / 暂无数据`;
            }
            return `共 ${total} 条 / 当前 ${range[0]} - ${range[1]} 条`;
        }
    },
    props: {
        pagination: {
            required: true
        },
        pageSizeOptions: {
            type: Array,
            default: () => [
                "1",
                "3",
                "5",
                "10",
                "15",
                "20",
                "30",
                "50",
                "70",
                "100",
                "150",
                "200",
                "300"
            ]
        }
    },
    mounted() {}
};
</script>

<style lang="less" scope>
.pageinfo {
    text-align: center;
    padding: 30px 0;
}
</style>